import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable()
export class ResourcesService {

  constructor(
  private http: HttpClient) {
  }

  /** GET resources from the server */
  getResources (_idToken: string): Observable<string[]> {
    return this.http.get<string[]>(environment.apiConfig.uri + '/systems').
    pipe(
      catchError(this.handleError('getJobs', [])))
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
private handleError<T> (operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {
    // Let the app keep running by returning an empty result.
    return of(result as T);
  };
}
}
